module.exports = __webpack_public_path__ + "img/厚朴.92a6bcfd.jpg";